
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonInput, ModalController } from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CustomValidators, Musician, profanityValidator } from 'bandon-shared';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonNote, IonTitle, IonToolbar } from "@ionic/angular/standalone";
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';

@Component({
  selector: 'app-musician-modal',
  templateUrl: './musician-modal.component.html',
  styleUrls: ['./musician-modal.component.scss'],
  standalone: true,
  imports: [
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonIcon,
    IonTitle,
    IonContent,
    IonItem,
    IonLabel,
    IonNote,
    IonFooter,
    IonInput,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
]
})
export class MusicianModalComponent  implements OnInit {
  modalController = inject(ModalController)
  translate = inject(TranslateService)
  fb = inject(FormBuilder)

  @Input() musician: Musician = { id: -1, surname: '', firstname: ''};
  @Input() modalTitle: string = this.translate.instant('TUNES.CREATEMUSICIAN');

  musicianForm: FormGroup = this.fb.group({
    firstname: [this.musician.firstname, [Validators.required, profanityValidator()]],
    surname: [this.musician.surname, profanityValidator()],
    homepage: [this.musician.homepage, CustomValidators.validUrlValidator],
    birth: [this.musician.year_of_birth],
    death: [this.musician.year_of_death]
  });

  constructor() {
    addIcons({ close })
  }

  get firstnameInput() {
    return this.musicianForm.get('firstname');
  }

  get surnnameInput() {
    return this.musicianForm.get('surname');
  }

  get homepageInput() {
    return this.musicianForm.get('homepage');
  }

  ngOnInit() {}

  dismiss() {
    this.modalController.dismiss();
  }

  save() {
    this.modalController.dismiss(this.musician);
  }
}
